import { Button } from "primereact/button";

import type { FilterPanelSaveButtonViewProps } from "./types-save-button";

export function FilterPanelSaveButtonView({
  label,
  disabled,
  onClick,
  testId,
  rest,
}: FilterPanelSaveButtonViewProps) {
  return (
    <Button
      type="button"
      label={label}
      severity="secondary"
      aria-haspopup="dialog"
      disabled={disabled}
      onClick={onClick}
      data-testid={testId}
      {...rest}
    />
  );
}
